import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useRole } from '../../lib/roles'
import Page from '../../components/layout/Page'
import PersonalHours from '../../components/PersonalHours'
import TimesheetClockCard from '../../components/TimesheetClockCard'

export default function TimesheetPage() {
  const { role, attendanceEmployee, loading } = useRole()
  const [shiftState, setShiftState] = useState('unknown')
  const activeShift = shiftState === 'working' || shiftState === 'on_break'
  if (loading) return <p role="status">Loading…</p>
  if (role === 'office' && !attendanceEmployee) return <Navigate to="/exchange-desk" replace />
  if ((role === 'manager' || role === 'admin') && !attendanceEmployee) return <Navigate to="/timesheet-review" replace />
  return <Page size="md" title={activeShift ? 'My timesheet' : undefined} subtitle={activeShift ? 'Track your shift and unpaid breaks.' : undefined}>
    <TimesheetClockCard onShiftStateChange={setShiftState} />
    <PersonalHours shiftState={shiftState} />
  </Page>
}
